import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

interface ChatTypingIndicatorProps {
	/** What the Tutor is doing right now, when it is known */
	label?: string | null;
}

const SLIDE_PX = 6;

const ChatTypingIndicator = ({ label }: ChatTypingIndicatorProps) => {
	const reduceMotion = useReducedMotion();
	const slide = reduceMotion ? 0 : SLIDE_PX;

	return (
		<div className="flex flex-col items-start gap-1" aria-live="polite">
			{/* a fixed height, so the dots do not move as the line changes */}
			<div className="h-4 overflow-hidden px-1">
				<AnimatePresence mode="wait" initial={false}>
					{label && (
						<motion.span
							key={label}
							className="block text-slate-500/80 text-xs leading-4 dark:text-slate-400/80"
							initial={{ opacity: 0, y: slide }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0, y: -slide }}
							transition={{ duration: 0.2, ease: "easeOut" }}
						>
							{label}
						</motion.span>
					)}
				</AnimatePresence>
			</div>
			<div className="flex items-center gap-1 rounded-2xl bg-slate-100 px-3.5 py-3 dark:bg-slate-800">
				{[0, 1, 2].map((i) => (
					<span
						key={i}
						className="size-1.5 animate-bounce rounded-full bg-slate-400"
						style={{ animationDelay: `${i * 0.15}s` }}
					/>
				))}
			</div>
		</div>
	);
};

export default ChatTypingIndicator;
